import { TableDefinition } from '../../../core/models/table-definition.model'

export class AuctionTableFactory {
    auctionDesktopTable(perUnitType?: string, perUnitName?: string): TableDefinition {
        const colDef = {
            columns: [
                {
                    columnDef: 'lotNumber',
                    header: 'Lot No.',
                    formatter: 'text'
                },
                {
                    columnDef: 'title',
                    header: 'Title',
                    formatter: 'canBeWithdrawn'
                },
                {
                    columnDef: 'aveWeight',
                    header: 'Avg Weight',
                    formatter: 'aveWeight'
                },
                {
                    columnDef: 'stockType',
                    header: 'Category',
                    formatter: 'canBeWithdrawn'
                },
                {
                    columnDef: 'activityStatus',
                    header: 'Status',
                    formatter: 'status'
                },
                {
                    columnDef: perUnitType ? perUnitType : 'priceHead',
                    header: perUnitName ? `Price per ${perUnitName}` : 'Price/Head',
                    formatter: perUnitType ? perUnitType : 'priceHead'
                }
            ]
        }
        if (!perUnitType) {
            colDef.columns.push({
                columnDef: 'priceKg',
                header: 'Price/Kg',
                formatter: 'priceKg'
            })
        }
        return colDef
    }

    geneticTable(perUnitType?: string, perUnitName?: string): TableDefinition {
        return {
            columns: [
                {
                    columnDef: 'lotNumber',
                    header: 'Lot No.',
                    formatter: 'text'
                },
                {
                    columnDef: 'title',
                    header: 'Title',
                    formatter: 'canBeWithdrawn'
                },
                {
                    columnDef: 'activityStatus',
                    header: 'Status',
                    formatter: 'status'
                },
                {
                    columnDef: perUnitType ? perUnitType : 'priceHead',
                    header: perUnitName ? `Price per ${perUnitName}` : 'Price per Head',
                    formatter: perUnitType ? perUnitType : 'priceHead'
                },
                {
                    columnDef: 'purchaserName',
                    header: 'Purchaser',
                    formatter: 'geneticPurchaser'
                }
            ]
        }
    }

    auctionMobileTable(perUnitType?: string, perUnitName?: string): TableDefinition {
        const colDef = {
            columns: [
                {
                    columnDef: 'activityStatus',
                    header: '',
                    formatter: 'status'
                },
                {
                    columnDef: 'lotNumber',
                    header: 'Lot',
                    formatter: 'text'
                },
                {
                    columnDef: 'title',
                    header: 'Title',
                    formatter: 'canBeWithdrawn'
                },
                {
                    columnDef: perUnitType ? perUnitType : 'priceHead',
                    header: perUnitName ? `Price per ${perUnitName}` : '$/Head',
                    formatter: perUnitType ? perUnitType : 'priceHead'
                }
            ]
        }
        if (!perUnitType) {
            colDef.columns.push({
                columnDef: 'priceKg',
                header: '$/Kg',
                formatter: 'priceKg'
            })
        }
        return colDef
    }

    geneticMobileTable(perUnitType?: string, perUnitName?: string): TableDefinition {
        return {
            columns: [
                {
                    columnDef: 'activityStatus',
                    header: '',
                    formatter: 'status'
                },
                {
                    columnDef: 'lotNumber',
                    header: 'Lot No.',
                    formatter: 'text'
                },
                {
                    columnDef: 'title',
                    header: 'Title',
                    formatter: 'canBeWithdrawn'
                },
                {
                    columnDef: perUnitType ? perUnitType : 'priceHead',
                    header: perUnitName ? `Price per ${perUnitName}` : 'Price per Head',
                    formatter: perUnitType ? perUnitType : 'priceHead'
                },
                {
                    columnDef: 'purchaserName',
                    header: 'Purchaser',
                    formatter: 'geneticPurchaser'
                }
            ]
        }
    }

    auctionPickChildrenDesktopTable(penOrLot: string): TableDefinition {
        const colDef = {
            columns: [
                {
                    columnDef: 'lotNumber',
                    header: penOrLot + ' No.',
                    formatter: 'lotNumber'
                },
                {
                    columnDef: 'pickNotes',
                    header: 'Notes',
                    formatter: 'pickNotes'
                },
                {
                    columnDef: 'activityStatus',
                    header: 'Status',
                    formatter: 'status'
                },
                {
                    columnDef: 'childSoldPrice',
                    header: 'Price',
                    formatter: 'childSoldPrice'
                }
            ]
        }
        return colDef
    }

    auctionPickChildrenMobileTable(penOrLot: string): TableDefinition {
        const colDef = {
            columns: [
                {
                    columnDef: 'lotNumber',
                    header: penOrLot + ' No.',
                    formatter: 'lotNumber'
                },
                {
                    columnDef: 'pickNotes',
                    header: 'Notes',
                    formatter: 'pickNotes'
                },
                {
                    columnDef: 'activityStatus',
                    header: 'Status',
                    formatter: 'status'
                },
                {
                    columnDef: 'childSoldPrice',
                    header: 'Price',
                    formatter: 'childSoldPrice'
                }
            ]
        }
        return colDef
    }

    auctionRunoutChildrenDesktopTable(penOrLot: string): TableDefinition {
        const colDef = {
            columns: [
                {
                    columnDef: 'lotNumber',
                    header: penOrLot + ' No.',
                    formatter: 'lotNumber'
                },
                {
                    columnDef: 'tally',
                    header: 'Tally',
                    formatter: 'text'
                },
                {
                    columnDef: 'activityStatus',
                    header: 'Status',
                    formatter: 'status'
                },
                {
                    columnDef: 'childSoldPrice',
                    header: 'Price',
                    formatter: 'childSoldPrice'
                }
            ]
        }
        return colDef
    }

    auctionRunoutChildrenMobileTable(penOrLot: string): TableDefinition {
        const colDef = {
            columns: [
                {
                    columnDef: 'lotNumber',
                    header: penOrLot + ' No.',
                    formatter: 'lotNumber'
                },
                {
                    columnDef: 'tally',
                    header: 'Tally',
                    formatter: 'text'
                },
                {
                    columnDef: 'activityStatus',
                    header: 'Status',
                    formatter: 'status'
                },
                {
                    columnDef: 'childSoldPrice',
                    header: 'Price',
                    formatter: 'childSoldPrice'
                }
            ]
        }
        return colDef
    }
}
